module.exports = __webpack_public_path__ + "static/img/GalaxyTabS6.98b59485.png";